import { ReactNode } from 'react';

export const FiltersContainer = ({ children }: { children: ReactNode }) => (
  <div className="flex justify-between items-center w-full pr-6">{children}</div>
);
